import { HTTP, authHeader } from './http-service';

class DisputesMergeService {
    getDisputeByReference(disputeReference) {
        return HTTP.get(`/dispute/byreference/${disputeReference}`, { headers: authHeader() }).then((response) => {
            return response.data;
        });
    }
    mergeDisputes(payload) {
        return HTTP.post(`/dispute/${payload.disputeId}/merge`, payload.disputes, { headers: authHeader() }).then((response) => {
            return response.data;
        });
    }
}

export default new DisputesMergeService();
